// Import all Table 2 metadata files directly from src/data
import table2_moisesdb_eg01_metadata from './data/table2_moisesdb_eg01_metadata.json';
import table2_moisesdb_eg02_metadata from './data/table2_moisesdb_eg02_metadata.json';
import table2_moisesdb_eg03_metadata from './data/table2_moisesdb_eg03_metadata.json';
import table2_moisesdb_eg04_metadata from './data/table2_moisesdb_eg04_metadata.json';
import table2_moisesdb_eg05_metadata from './data/table2_moisesdb_eg05_metadata.json';
import table2_musdb_eg01_metadata from './data/table2_musdb_eg01_metadata.json';
import table2_musdb_eg02_metadata from './data/table2_musdb_eg02_metadata.json';
import table2_musdb_eg03_metadata from './data/table2_musdb_eg03_metadata.json';
import table2_musdb_eg04_metadata from './data/table2_musdb_eg04_metadata.json';
import table2_musdb_eg05_metadata from './data/table2_musdb_eg05_metadata.json';

// Table 2 Workflow Comparison Data Structure
export const table2Examples = [
    // MoisesDB examples
    {
        id: 'table2_moisesdb_eg01',
        dataset: 'MoisesDB',
        name: 'eg01_0357_72c6f013_seg04',
        displayName: 'Set 01',
        metadata: table2_moisesdb_eg01_metadata
    },
    {
        id: 'table2_moisesdb_eg02',
        dataset: 'MoisesDB',
        name: 'eg02_1172_bb45cf1a_seg04',
        displayName: 'Set 02',
        metadata: table2_moisesdb_eg02_metadata
    },
    {
        id: 'table2_moisesdb_eg03',
        dataset: 'MoisesDB',
        name: 'eg03_1473_f4b735de_seg00',
        displayName: 'Set 03',
        metadata: table2_moisesdb_eg03_metadata
    },
    {
        id: 'table2_moisesdb_eg04',
        dataset: 'MoisesDB',
        name: 'eg04_1297_aa600069_seg01',
        displayName: 'Set 04',
        metadata: table2_moisesdb_eg04_metadata
    },
    {
        id: 'table2_moisesdb_eg05',
        dataset: 'MoisesDB',
        name: 'eg05_0610_69dff382_seg02',
        displayName: 'Set 05',
        metadata: table2_moisesdb_eg05_metadata
    },

    // MusDB examples
    {
        id: 'table2_musdb_eg01',
        dataset: 'MusDB',
        name: 'eg01_0760_Louis_Cressy_Band__Good_Time_seg04',
        displayName: 'Set 01',
        metadata: table2_musdb_eg01_metadata
    },
    {
        id: 'table2_musdb_eg02',
        dataset: 'MusDB',
        name: 'eg02_0705_Faces_On_Film__Waiting_For_Ga_seg03',
        displayName: 'Set 02',
        metadata: table2_musdb_eg02_metadata
    },
    {
        id: 'table2_musdb_eg03',
        dataset: 'MusDB',
        name: 'eg03_0928_Tom_McKenzie__Directions_seg02',
        displayName: 'Set 03',
        metadata: table2_musdb_eg03_metadata
    },
    {
        id: 'table2_musdb_eg04',
        dataset: 'MusDB',
        name: 'eg04_0938_BKS__Too_Much_seg00',
        displayName: 'Set 04',
        metadata: table2_musdb_eg04_metadata
    },
    {
        id: 'table2_musdb_eg05',
        dataset: 'MusDB',
        name: 'eg05_0022_The_So_So_Glos__Emergency_seg03',
        displayName: 'Set 05',
        metadata: table2_musdb_eg05_metadata
    }
];

// Table 2 Model Configurations - Workflow Comparison
export const table2ModelConfigs = [
    {
        id: 'model_C_ii_two_pass',
        name: 'C-(ii)',
        description: '2 Pass',
        workflow: '2-pass workflow with refinement',
        folderName: 'model_C_ii_two_pass'
    },
    {
        id: 'model_C_ii_one_pass',
        name: 'C-(ii)',
        description: '1 Pass',
        workflow: '1-pass simultaneous generation',
        folderName: 'model_C_ii_one_pass'
    },
    {
        id: 'model_A_i_full_iter',
        name: 'A-(i)',
        description: 'K pass',
        workflow: 'K-pass iterative generation (baseline)',
        folderName: 'model_A_i_full_iter'
    }
];

// Helper function to get audio file paths for Table 2
export const getTable2AudioPath = (example, modelConfig, stemIndex = null) => {
    const datasetFolder = example.dataset.toLowerCase() === 'moisesdb' ? 'moisesdb_from_scratch' : 'musdb_from_scratch';
    const basePath = `${process.env.PUBLIC_URL || ''}/audio/table02/${datasetFolder}/${example.name}/${modelConfig.folderName}`;

    if (stemIndex !== null) {
        // Get the stem type from the all_stems array
        const allStems = example.metadata.all_stems.replace(/[[\]']/g, '').split(' ').filter(stem => stem.length > 0);
        const stemType = allStems[stemIndex];

        // Find the folder that corresponds to this stem type
        const subdirMapping = example.metadata.subdir_output_stems;
        const folderName = Object.keys(subdirMapping).find(key => subdirMapping[key] === stemType);

        if (folderName) {
            return `${basePath}/${folderName}/output.mp3`;
        } else {
            console.error('Could not find folder for stem type:', stemType);
            return `${basePath}/00_from_scratch_0in_${allStems.length}out/output.mp3`;
        }
    } else {
        // Mixed audio path
        return `${basePath}/output_mix.mp3`;
    }
};

// Hardcoded generation times to avoid async loading delays
const GENERATION_TIMES = {
    "moisesdb_from_scratch/eg01_0357_72c6f013_seg04/model_A_i_full_iter": 8.301883935928345,
    "moisesdb_from_scratch/eg01_0357_72c6f013_seg04/model_C_ii_one_pass": 3.6110682487487793,
    "moisesdb_from_scratch/eg01_0357_72c6f013_seg04/model_C_ii_two_pass": 4.151340484619141,
    "moisesdb_from_scratch/eg02_1172_bb45cf1a_seg04/model_A_i_full_iter": 6.808615207672119,
    "moisesdb_from_scratch/eg02_1172_bb45cf1a_seg04/model_C_ii_one_pass": 3.1163487434387207,
    "moisesdb_from_scratch/eg02_1172_bb45cf1a_seg04/model_C_ii_two_pass": 3.903104066848755,
    "moisesdb_from_scratch/eg03_1473_f4b735de_seg00/model_A_i_full_iter": 4.016861438751221,
    "moisesdb_from_scratch/eg03_1473_f4b735de_seg00/model_C_ii_one_pass": 2.004027843475342,
    "moisesdb_from_scratch/eg03_1473_f4b735de_seg00/model_C_ii_two_pass": 3.0097384452819824,
    "moisesdb_from_scratch/eg04_1297_aa600069_seg01/model_A_i_full_iter": 7.569755554199219,
    "moisesdb_from_scratch/eg04_1297_aa600069_seg01/model_C_ii_one_pass": 3.1302647590637207,
    "moisesdb_from_scratch/eg04_1297_aa600069_seg01/model_C_ii_two_pass": 3.6807923316955566,
    "moisesdb_from_scratch/eg05_0610_69dff382_seg02/model_A_i_full_iter": 5.439276218414307,
    "moisesdb_from_scratch/eg05_0610_69dff382_seg02/model_C_ii_one_pass": 2.4513425827026367,
    "moisesdb_from_scratch/eg05_0610_69dff382_seg02/model_C_ii_two_pass": 3.1818878650665283,
    "musdb_from_scratch/eg01_0760_Louis_Cressy_Band__Good_Time_seg04/model_A_i_full_iter": 4.071589469909668,
    "musdb_from_scratch/eg01_0760_Louis_Cressy_Band__Good_Time_seg04/model_C_ii_one_pass": 1.9989087581634521,
    "musdb_from_scratch/eg01_0760_Louis_Cressy_Band__Good_Time_seg04/model_C_ii_two_pass": 3.056544065475464,
    "musdb_from_scratch/eg02_0705_Faces_On_Film__Waiting_For_Ga_seg03/model_A_i_full_iter": 5.538135290145874,
    "musdb_from_scratch/eg02_0705_Faces_On_Film__Waiting_For_Ga_seg03/model_C_ii_one_pass": 2.491814374923706,
    "musdb_from_scratch/eg02_0705_Faces_On_Film__Waiting_For_Ga_seg03/model_C_ii_two_pass": 3.257037401199341,
    "musdb_from_scratch/eg03_0928_Tom_McKenzie__Directions_seg02/model_A_i_full_iter": 5.504251003265381,
    "musdb_from_scratch/eg03_0928_Tom_McKenzie__Directions_seg02/model_C_ii_one_pass": 2.500948190689087,
    "musdb_from_scratch/eg03_0928_Tom_McKenzie__Directions_seg02/model_C_ii_two_pass": 3.259740114212036,
    "musdb_from_scratch/eg04_0938_BKS__Too_Much_seg00/model_A_i_full_iter": 4.149491786956787,
    "musdb_from_scratch/eg04_0938_BKS__Too_Much_seg00/model_C_ii_one_pass": 1.9769082069396973,
    "musdb_from_scratch/eg04_0938_BKS__Too_Much_seg00/model_C_ii_two_pass": 3.034613609313965,
    "musdb_from_scratch/eg05_0022_The_So_So_Glos__Emergency_seg03/model_A_i_full_iter": 5.526077747344971,
    "musdb_from_scratch/eg05_0022_The_So_So_Glos__Emergency_seg03/model_C_ii_one_pass": 2.442614793777466,
    "musdb_from_scratch/eg05_0022_The_So_So_Glos__Emergency_seg03/model_C_ii_two_pass": 3.291517972946167
};

// Helper function to get generation time for a model (now synchronous)
export const getGenerationTime = (example, modelConfig) => {
    const datasetFolder = example.dataset.toLowerCase() === 'moisesdb' ? 'moisesdb_from_scratch' : 'musdb_from_scratch';
    const key = `${datasetFolder}/${example.name}/${modelConfig.folderName}`;
    return GENERATION_TIMES[key] || null;
};

// Load example metadata synchronously (same as Table 1)
export const loadTable2ExampleMetadata = (example) => {
    try {
        console.log('Loading Table 2 metadata for example:', example.name);
        const metadata = example.metadata; // Directly access imported metadata

        if (!metadata) {
            console.error('No metadata found for example:', example.name);
            return null;
        }

        // Parse the all_stems field (Python string format like "['VOCALS' 'BASSES']")
        let allStems = [];
        if (metadata.all_stems) {
            try {
                // Remove brackets and quotes, split by spaces
                const stemsString = metadata.all_stems.replace(/[[\]']/g, '');
                allStems = stemsString.split(' ').filter(stem => stem.length > 0);
            } catch (parseError) {
                console.error('Failed to parse all_stems:', parseError);
                allStems = [];
            }
        }

        const processedMetadata = {
            caption: metadata.caption_orig,
            allStems: allStems,
            stemMapping: metadata.subdir_output_stems || {}
        };

        console.log('Table 2 metadata processed successfully:', processedMetadata.allStems.length, 'stems');
        return processedMetadata;
    } catch (error) {
        console.error('Failed to process Table 2 metadata for', example.name, error);
        return null;
    }
};
